import { useDispatch, useSelector } from "react-redux";
import ModalStandard from "../../../common/components/Modal/ModalStandard";
import { closeStandardModal } from "../../../common/state/slice/modal/modalSlice";
import { AppDispatch } from "../../../common/state/store";
import { IMedia } from "../../../model/unityObject";
import { Gallery } from "../../gallery/Gallery";
import Alert from "../../../common/components/Alert/Alert";
import { getCurrentProject } from "src/features/projects/state/projectsSlice";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { isStringNullOrEmpty } from "src/common/util/isStringNullOrEmpty";
import { getMediaSearch } from "src/features/gallery/state/gallerySlice";
import { setAlert } from "src/features/alert/state/alertsSlice";
import { useTranslation } from "react-i18next";

// Todo: have 'nodeId' for: ["profile", "organization", "background_audio"]

const ModalGallery = ({
  onMediaChange,
  onCancel,
  nodeId,
  contentType,
  allowedMediaTypeOverride,
}: {
  nodeId: string;
  onMediaChange: (id: IMedia) => void;
  onCancel?: () => void;
  contentType?: string;
  allowedMediaTypeOverride?: string;
}) => {
  const dispatch: AppDispatch = useDispatch();
  const { t } = useTranslation();

  const onCancelDefault = () => {
    dispatch(closeStandardModal("modal-gallery"));
  };

  const { pathname } = useLocation();
  const currentProject = useSelector(getCurrentProject);
  const currentMediaSearch = useSelector(getMediaSearch);
  const [navTitle, setNavTitle] = useState("");

  // WIXAR-3811 | Incomplete path displayed in ModalGallery when editing a project
  useEffect(() => {
    if (/^\/courses\/\d{1,256}\/list\/\d{1,256}\/graph\/node\/[^/]+\/\d{1,256}$/.test(pathname)) {
      setNavTitle(currentProject?.name);
    }
  }, [pathname, currentProject]);

  return (
    <ModalStandard
      id="modal-gallery"
      modalType="standard"
      clickOnBackgroundClose={false}
      fullScreen
      isStatic
    >
      <div className="flex w-full">
        <div className="text-center ">
          <Alert />
        </div>
        <div className="grow overflow-y-visible ">
          <Gallery
            onConfirmSelectMedia={(media: IMedia) => {
              // Validate media type matches expected type (Story 13.20: AC2)
              const expectedMediaType = currentMediaSearch?.mediaType;

              // Check if there's a specific media type requirement (not "all" or empty)
              const hasSpecificTypeRequirement =
                !isStringNullOrEmpty(expectedMediaType) && expectedMediaType !== "all";

              // If specific type required, validate it matches
              if (hasSpecificTypeRequirement && media.type !== expectedMediaType) {
                dispatch(
                  setAlert({
                    isOpen: true,
                    type: "danger",
                    msg: t("error.invalidMediaType", {
                      expected: expectedMediaType,
                      actual: media.type,
                    }),
                  }),
                );
                return; // Block invalid selection
              }

              // Validate 360 tag if specified
              const expected360Tag = currentMediaSearch?.media360tag;
              const hasSpecific360TagRequirement =
                !isStringNullOrEmpty(expected360Tag) && expected360Tag !== "all";

              if (hasSpecific360TagRequirement && media.media_360_tag !== expected360Tag) {
                dispatch(
                  setAlert({
                    isOpen: true,
                    type: "danger",
                    msg: t("error.invalid360Tag", {
                      expected: expected360Tag,
                      actual: media.media_360_tag,
                    }),
                  }),
                );
                return; // Block invalid selection
              }

              // All validations passed
              onMediaChange(media);
            }}
            onCancel={() => (onCancel ? onCancel() : onCancelDefault())}
            nodeId={nodeId}
            contentType={contentType}
            title={navTitle}
            allowedMediaTypeOverride={allowedMediaTypeOverride}
            isModalEdit={false}
            isMediaPickerMode
            isModalGallery
          />
        </div>
      </div>
    </ModalStandard>
  );
};

export default ModalGallery;
